import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from '@mui/material';
import { dayMaxFe } from './dailyTasksUtils';

function DayRewardsForm({ form, onChange, onSave, saving }) {
  const total = dayMaxFe(form);

  const setField = (key) => (e) => {
    const value = e.target.value === '' ? '' : Number(e.target.value);
    onChange({ ...form, [key]: value });
  };

  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        Fans earn FE when a <strong>whole group</strong> is finished, not per task. Finishing every
        group that day also pays the <strong>completion bonus</strong>.
      </Alert>
      <Alert severity="warning" sx={{ mb: 2 }}>
        Fans who already opened this IST day keep the reward amounts they were shown. New amounts
        apply only to fans who open the day after you save. Saving never claws back credited FE.
      </Alert>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            type="number"
            label="Missions group FE"
            value={form.missions_group_fe}
            onChange={setField('missions_group_fe')}
            helperText="Paid once when all mission tasks done"
            inputProps={{ min: 0 }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            type="number"
            label="Challenge group FE"
            value={form.challenge_group_fe}
            onChange={setField('challenge_group_fe')}
            helperText="Paid once when all challenge/quiz cards done"
            inputProps={{ min: 0 }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            type="number"
            label="Opinions group FE"
            value={form.opinions_group_fe}
            onChange={setField('opinions_group_fe')}
            helperText="Hot takes + predictions together"
            inputProps={{ min: 0 }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            fullWidth
            type="number"
            label="Day completion bonus"
            value={form.completion_bonus_fe}
            onChange={setField('completion_bonus_fe')}
            helperText="Paid when all non-empty groups done"
            inputProps={{ min: 0 }}
          />
        </Grid>
      </Grid>

      <Box display="flex" alignItems="center" justifyContent="space-between" mt={2}>
        <Typography variant="subtitle1">
          Day max: <strong>{total} FE</strong>
        </Typography>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {saving ? 'Saving…' : 'Save rewards'}
        </Button>
      </Box>
    </Box>
  );
}

export default DayRewardsForm;
